<template>
	<svg
		width="12px"
		height="18px"
		viewBox="0 0 12 18"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="participant mic on icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g id="Combined-Shape-2" fill="#00DAB6" fill-rule="nonzero">
				<path
					d="M11.3236994,6.50464548 C11.7052023,6.50464548 12,6.80391198 12,7.18239609 L12,7.18239609 L12,8.85476773 C12,12.1819071 9.83236994,14.4968215 6.66763006,14.7784841 L6.66763006,14.7784841 L6.66763006,16.6356968 L9.70231214,16.6356968 C10.0751445,16.6356968 10.3786127,16.9349633 10.3786127,17.3134474 C10.3786127,17.6919315 10.0751445,18 9.70231214,18 L9.70231214,18 L2.29768786,18 C1.92485549,18 1.62138728,17.6919315 1.62138728,17.3134474 C1.62138728,16.9349633 1.92485549,16.6356968 2.29768786,16.6356968 L2.29768786,16.6356968 L5.33236994,16.6356968 L5.33236994,14.7784841 C2.16763006,14.4968215 0,12.1819071 0,8.85476773 L0,8.85476773 L0,7.18239609 C0,6.80391198 0.294797688,6.50464548 0.667630058,6.50464548 C1.04913295,6.50464548 1.34393064,6.80391198 1.34393064,7.18239609 L1.34393064,7.18239609 L1.34393064,8.80195599 C1.34393064,11.6361858 3.19942197,13.5198044 6,13.5198044 C8.80057803,13.5198044 10.6473988,11.6361858 10.6473988,8.80195599 L10.6473988,8.80195599 L10.6473988,7.18239609 C10.6473988,6.80391198 10.9508671,6.50464548 11.3236994,6.50464548 Z M6,0 C7.79479769,0 9.03468208,1.36430318 9.03468208,3.30953545 L9.03468208,3.30953545 L9.03468208,8.52909535 C9.03468208,10.4831296 7.79479769,11.8474328 6,11.8474328 C4.20520231,11.8474328 2.9566474,10.4831296 2.9566474,8.52909535 L2.9566474,8.52909535 L2.9566474,3.30953545 C2.9566474,1.36430318 4.20520231,0 6,0 Z"
					id="Combined-Shape"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MicOnParticipant',
}
</script>
